import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, NoRestApiHelper } from '@services';
import { parseNumbers } from '@shared/utils/helpers.util';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  constructor(
    private http: HttpClient,
    protected configService: ConfigService,
    protected noRestApiHelper: NoRestApiHelper,
  ) {}

  changeFullName(fullName: { lastName; firstName; middleName }, phone?) {
    const postObject = {
      system: this.configService.get('system'),
      modelName: 'LoyaltyUser',
      calledMethod: 'updateLoyaltyUser',
      methodProperties: {
        LastName: fullName.lastName,
        FirstName: fullName.firstName,
        MiddleName: fullName.middleName,
        Phone: phone,
      },
    };

    return this.http
      .post(
        `${this.configService.get(
          'apiUrl',
        )}json/LoyaltyUser/getLoyaltyUserByLogin`,
        postObject,
      )
      .pipe(map((data) => this.noRestApiHelper.checkErrors({ data })));
  }

  changeBirthDate(date: string) {
    const postObject = {
      system: this.configService.get('system'),
      modelName: 'LoyaltyUser',
      calledMethod: 'updateLoyaltyUser',
      methodProperties: {
        BirthDate: date,
      },
    };

    return this.http
      .post(
        `${this.configService.get(
          'apiUrl',
        )}json/LoyaltyUser/getLoyaltyUserByLogin`,
        postObject,
      )
      .pipe(map((data) => this.noRestApiHelper.checkErrors({ data })));
  }

  changePhone(phone: string) {
    const postObject = {
      system: this.configService.get('system'),
      modelName: 'LoyaltyUser',
      calledMethod: 'updateLoyaltyUser',
      methodProperties: {
        Phone: phone,
      },
    };

    return this.http
      .post(
        `${this.configService.get(
          'apiUrl',
        )}json/LoyaltyUser/getLoyaltyUserByLogin`,
        postObject,
      )
      .pipe(map((data) => this.noRestApiHelper.checkErrors({ data })));
  }

  checkVerificationCode(code: string) {
    const postObject = {
      system: this.configService.get('system'),
      modelName: 'LoyaltyUser',
      calledMethod: 'checkVerificationCodeForUpdateLoyaltyUser',
      methodProperties: {
        VerificationCode: code,
      },
    };

    return this.http
      .post(
        `${this.configService.get(
          'apiUrl',
        )}json/LoyaltyUser/getLoyaltyUserByLogin`,
        postObject,
      )
      .pipe(map((data) => this.noRestApiHelper.checkErrors({ data })));
  }

  activateAccount(activationData) {
    const body = {
      system: this.configService.get('system'),
      modelName: 'ContractGeneral',
      calledMethod: 'activateContractByCode',
      methodProperties: {
        Code: activationData.activationCode,
        CustomerPhone: parseNumbers(activationData.phone),
        FirstName: activationData.name,
        MiddleName: activationData.middleName,
        LastName: activationData.surname,
        Email: activationData.email,
        Password: activationData.password,
      },
    };
    return this.http
      .post(`${this.configService.get('apiUrl')}json/`, body)
      .pipe(map((data) => this.noRestApiHelper.checkErrors({ data })));
  }
}
